import aa from 'search-insights'

const ALGOLIA_INSIGHTS_COOKIE = '_ALGOLIA'

/**
 * Consent gate for Algolia Insights (AMS-737, analysis point 1).
 *
 * search-insights is initialised opted out and cookieless by the design-system
 * plugin (`algolia-insights`).
 * This plugin handles insight consent when functional cookies are granted (C0003)
 */
export default defineNuxtPlugin({
  name: 'algolia-insights-consent',
  dependsOn: ['algolia-insights'],
  setup() {
    const { algolia } = useRuntimeConfig().public
    if (!algolia?.applicationId || !algolia?.apiKey) return

    const enableTracking = () =>
      // `partial: true` merges these options with existing ones (e.g. appId and key)
      aa('init', { partial: true, userHasOptedOut: false, useCookie: true })

    const disableTracking = () => {
      aa('init', { partial: true, userHasOptedOut: true, useCookie: false })
      // Remove token and cookie, the SDK does not do it automatically on opt-out
      aa('setUserToken', undefined as unknown as string)
      document.cookie = `${ALGOLIA_INSIGHTS_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
    }

    const { hasConsent } = useUserCookieConsent({
      categories: ['C0003'],
      onConsentChange: current =>
        current ? enableTracking() : disableTracking(),
    })
    if (hasConsent.value) enableTracking()
  },
})
